// Site-wide settings & contact details.
//
// FALLBACK CONTENT ONLY. The live values are managed in the CMS and stored in
// Firestore at `settings/site`; `siteSettingsService.getSiteSettings()` merges
// the stored document over this object. Keeping a complete copy here means the
// header and footer render correctly on first paint and still render if
// Firestore is unreachable — it is not the source of truth.
export const SITE = {
  company: "Athena Scientific Pte Ltd",
  shortName: "Athena Scientific",
  website: "athena-sci.com",
  tagline: "Driven by Science. Focused on You.",
  keyQuestion: "How Can We Help You?",
  uen: "202505145H",
  mobile: "+65 83656520",
  whatsapp: {
    number: "6583656520",
    url: "https://wa.me/6583656520",
    defaultMessage:
      "Hi Athena Scientific, I would like to enquire about your laboratory equipment.",
    // Shown as one-tap options before the chat opens, so an enquiry arrives
    // with context instead of an empty "Hi".
    presetQuestions: [
      "I would like a quotation for a product.",
      "I need help choosing the right equipment for my application.",
      "I would like to arrange servicing or preventive maintenance.",
      "I am interested in renting equipment.",
      "I have a question about an existing order.",
    ],
  },
  email: "info@athena-scientific.com",
  address: "21 Woodland Close, #08-40, Primz Bizhub, Singapore 737854",
  social: {
    facebook: "https://facebook.com/",
    instagram: "https://instagram.com/",
    tiktok: "https://tiktok.com/",
    linkedin: "",
  },
  logos: {
    color: "/logo-color.svg", // aqua/grey — for light backgrounds
    white: "/logo-white.svg", // white — for dark/photographic/aqua backgrounds
  },
};

// NOTE: the WhatsApp deep-link builder now lives on the site-data context
// (`useWaLink()`), so it uses the number and default message configured in the
// CMS rather than the fallback values above.
